
// AUTO-GENERATED BY fetch-maintenance.mjs. DO NOT EDIT.
export const maintenanceConfig = {
  "isMaintenanceMode": false
} as const;
